<script lang="ts">
import { defineComponent, Ref } from 'vue'
import { createNamespacedHelpers } from 'vuex-composition-helpers'
import DefaultLayout from '@/layouts/DefaultLayout.vue'
import { useI18n } from '../../setup/setup-i18n'

const { useGetters: useLoginDomainStoreGetters } = createNamespacedHelpers('LoginDomain')

export default defineComponent({
  name: 'ActivateSentPage',

  components: {
    DefaultLayout,
  },

  setup() {

    const { t } = useI18n()
    const contactSupportUrl = useLoginDomainStoreGetters(['contactSupportUrl']).contactSupportUrl as Ref<string>

    return {
      contactSupportUrl,
      t,
    }

  },
})

</script>

<template>
  <default-layout
    :title="t('ActivateSentPage.pageTitle')"
    :sub-title="t('ActivateSentPage.subTitle')"
  >
    <a
      class="contact-support-link block-button"
      target="_blank"
      :href="contactSupportUrl"
    >
      {{ t('ActivateSentPage.contactSupportButton') }}
    </a>
  </default-layout>
</template>

<style lang="scss" scoped>
.contact-support-link.block-button {
  @apply w-full block ml-0 text-center;
}
</style>
